// extracted by mini-css-extract-plugin
module.exports = {"hideOnDesktop":"styles_hideOnDesktop__8mAEG","hideOnTablet":"styles_hideOnTablet__OwAGN","hideOnMobile":"styles_hideOnMobile__MW875","card":"styles_card__2vEkB"};